import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {getProcessingContact, getPushProcessingDetail, getPushProcessingImage} from '@/api/miscellaneous';


export default /*#__PURE__*/_defineComponent({
  __name: 'PushProcessingDetail',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();

const images = ref<any[]>([]);
const detail = ref<any>({});

const tel = ref(false);
const isShowTel = ref(false);
const restrictShow = ref(false);
const restrictCode = ref('');

const isDataExist = ref(false);

const getDetail = () => {
    const id = route.query.id as string;
    getPushProcessingDetail({id}).then((res: any) => {
        // images.value = res.data.images;
        if (res.online) {
            detail.value = res;
            getImage();
        } else {
            isDataExist.value = true;
        }
    });
};
getDetail();

const getTell = (): void => {
    getProcessingContact({id: detail.value.id})
        .then(res => {
            tel.value = res;
            isShowTel.value = true;
        })
        .catch(e => {
            let {code} = e;
            if ([120].includes(code)) {
                restrictCode.value = code;
                restrictShow.value = true;
            }
        });
};

const getImage = () => {
    getPushProcessingImage({id: detail.value.id}).then((res: any) => {
        images.value = res;
    });
};

const jumpToUrl = (url: string): void => {
    window.location.href = url;
};

const __returned__ = { route, router, images, detail, tel, isShowTel, restrictShow, restrictCode, isDataExist, getDetail, getTell, getImage, jumpToUrl, ref, useRoute, useRouter, getProcessingContact, getPushProcessingDetail, getPushProcessingImage }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})